import { useState } from "react";
import { feedItems, guaguaCategories } from "@/mocks/guagua";

const tabs = [
  { id: "all", label: "全部围观" },
  ...guaguaCategories.map((c) => ({ id: c.id, label: c.name })),
];

const categoryNameMap = Object.fromEntries(guaguaCategories.map((c) => [c.name, c.emoji]));

export default function Feed() {
  const [active, setActive] = useState("all");
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const list = feedItems.filter((it) => {
    if (active === "all") return true;
    const cat = guaguaCategories.find((c) => c.name === it.category);
    return cat?.id === active;
  });

  const toggleLike = (id: string) => setLiked((p) => ({ ...p, [id]: !p[id] }));

  return (
    <section id="feed" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div>
            <p className="text-xs md:text-sm font-medium tracking-wide text-accent-600">🍉 新鲜出炉的瓜</p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              围观广场 · 大家都在整活
            </h2>
          </div>
          <p className="text-xs md:text-sm text-foreground-500">
            记得友好吃瓜，快乐第一，别较真～
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-2" role="tablist" aria-label="吃瓜分类切换">
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={active === t.id}
              onClick={() => setActive(t.id)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === t.id
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 border border-background-300 text-foreground-700 hover:border-primary-300"
              }`}
            >
              {t.id !== "all" && categoryNameMap[t.label] ? `${categoryNameMap[t.label]} ` : ""}
              {t.label}
            </button>
          ))}
        </div>

        <div className="mt-7 grid gap-5 lg:grid-cols-3 sm:grid-cols-2">
          {list.map((item) => {
            const emoji = categoryNameMap[item.category] || item.emoji;
            const isLiked = !!liked[item.id];
            return (
              <article
                key={item.id}
                className="flex flex-col rounded-2xl bg-background-50 border border-background-200 p-5 transition-colors hover:border-accent-300"
              >
                <div className="flex items-center gap-2">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-secondary-100 text-lg">{emoji}</span>
                  <div className="min-w-0">
                    <p className="text-xs text-primary-600 whitespace-nowrap">
                      {item.hot && <i className="ri-fire-fill mr-1 text-primary-500"></i>}
                      {item.category}
                    </p>
                    <p className="text-xs text-foreground-500 whitespace-nowrap">{item.author} · {item.school}</p>
                  </div>
                  <span className="ml-auto shrink-0 text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>

                <h3 className="mt-4 text-base md:text-lg font-medium leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.excerpt}
                </p>

                <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3">
                  <button
                    type="button"
                    onClick={() => toggleLike(item.id)}
                    aria-pressed={isLiked}
                    aria-label="点赞"
                    className={`flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs transition-colors whitespace-nowrap ${
                      isLiked ? "bg-primary-100 text-primary-700" : "bg-background-100 text-foreground-500 hover:text-primary-600"
                    }`}
                  >
                    <i className={`${isLiked ? "ri-heart-3-fill" : "ri-heart-3-line"}`}></i>
                    {item.likes + (isLiked ? 1 : 0)}
                  </button>
                  <button
                    type="button"
                    className="flex items-center gap-1.5 rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-500 hover:text-accent-600 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-chat-3-line"></i>
                    {item.comments}
                  </button>
                  <button
                    type="button"
                    className="ml-auto flex items-center gap-1 text-xs text-accent-600 hover:text-accent-700 whitespace-nowrap"
                  >
                    围观
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}